var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSeeTrailer = function SvgSeeTrailer(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 132 132",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.664 123.148C34.093 123.148 8.5 97.555 8.5 65.984 8.5 34.414 34.093 8.82 65.664 8.82s57.164 25.593 57.164 57.163c0 31.57-25.593 57.164-57.164 57.164m0-122.827C29.457.32 0 29.777 0 65.984c0 36.207 29.457 65.664 65.664 65.664s65.664-29.457 65.664-65.664S101.871.32 65.664.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.914 90.936 37.59-24.165a.935.935 0 0 0 0-1.574L53.936 41.046a.95.95 0 0 0-1.464.799v48.304a.936.936 0 0 0 1.442.787"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSeeTrailer);
export default ForwardRef;